<!--
  @Description cgc 拼团mvp - 拼团进程
-->
<template>
  <div class="left_process">
    <div class="process_percent">
      <div class="fenzi">{{ current }}</div>
      <div class="fenmu">/{{ total }}</div>
    </div>
    <div class="process_head_image" @click="invite">
      <img
        v-for="(item, index) in images"
        :key="index"
        class="head_image"
        :src="item.headImg !== '' ? item.headImg : defaultHeadImg"
      />
    </div>
    <SharePopup
      v-if="showSharePopup"
      :country="country"
      :recommendCode="recommendCode"
      :copyContent="copyContent"
      :shareConfig="shareConfig"
      @trackCopyClick="$emit('trackCopyClick')"
      @trackShareClick="$emit('trackShareClick')"
      @close="() => (showSharePopup = false)"
    />
  </div>
</template>
<script>
import SharePopup from './group_mvp_share_popup'
export default {
  components: {
    SharePopup,
  },
  props: {
    country: {
      type: String,
      default: 'MX',
    },
    // 兑换码：FOOD-J82RPF
    recommendCode: {
      type: String,
      default: '',
    },
    // 要复制的内容，比如：Hola, tu amigo te ha enviado MX$130.00 MXN de descuento para tu primer pedido. Obténlo aquí:
    copyContent: {
      type: String,
      default: '',
    },
    shareConfig: {
      type: Object,
      default: () => {},
    },
    images: {
      type: Array,
      default: () => [],
    },
    current: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      showSharePopup: false,
      defaultHeadImg:
        this.country === 'BR'
          ? require('../../../../assets/images/cgc/99/mvp_default_headimage.png')
          : require('../../../../assets/images/cgc/didi/mvp_default_headimage.png'),
    }
  },
  methods: {
    invite() {
      this.showSharePopup = true
    },
  },
}
</script>
<style scoped lang="stylus">
.left_process {
  .process_percent {
    display flex
    height 72px
    margin-bottom 12px
    .fenzi {
      height 72px
      font-family Aspira Demi
      font-size 72px
      color #FF8040
      text-align center
      line-height 72px
      font-weight 700
      letter-spacing 1.5px
    }
    .fenmu {
      margin-top 29px
      margin-left 4px
      height 36px
      font-family Aspira Demi
      font-size 36px
      color #000000
      line-height 36px
      font-weight 700
      letter-spacing 1.5px
    }

  }
  .process_head_image {
    height: 64px;
    .head_image {
      width 64px
      height 64px
      border-radius 64px
      background-color #FFFFFF
      &:not(:first-child) {
        margin-left -10px
        border 2px solid #FFFFFF
      }
      &:first-child {
        margin-bottom 1px
      }
    }
  }
}
</style>
